module.exports = __webpack_public_path__ + "static/media/icn-arrow-up.8f785c30.svg";